import React, { useState } from 'react';
import { Box, Typography, Select, MenuItem, styled } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const fileTypeOptions = [
  'Project Agreement',
  'Agreement',
  'Software Agreement',
  'Amendment',
  'Subscription Agreement',
  'Exhibit',
  'Compliance Document',
  'Spend Chart',
  'Market Price Chart',
  'Work Order',
  'Statement of Works',
  'Invoice',
  'Purchase Order',
  'Other Agreement',
  'Stakeholder Interview',
  'Annex',
  'Complaint',
  'Supplier Scorecard',
  'Sales Order',
  'Schedule',
  'Other Order',
  'Procurement Contract',
  'Master Service Agreement',
  'Service Level Agreement',
  'Tender Sheet'
];

const EditableText = styled(Typography)(({ theme }) => ({
  cursor: 'pointer',
  borderBottom: `1px dotted ${theme.palette.primary.main}`,
  '&:hover': {
    color: theme.palette.primary.main,
  },
}));

interface EditableFileTypeProps {
  value: string;
  fileId: string;
  onUpdate: (fileId: string, newType: string) => void;
}

const EditableFileType: React.FC<EditableFileTypeProps> = ({ value, fileId, onUpdate }) => {
  const theme = useTheme();
  const [isEditing, setIsEditing] = useState(false);
  const [fileType, setFileType] = useState(value || '');

  const handleClick = () => {
    setIsEditing(true);
  };

  const handleChange = (event: any) => {
    const newValue = event.target.value;
    setFileType(newValue);
    onUpdate(fileId, newValue);
    setIsEditing(false);
  };

  const handleClose = () => {
    setIsEditing(false);
  };

  return (
    <Box>
      {isEditing ? (
        <Select
          value={fileType}
          onChange={handleChange}
          onClose={handleClose}
          autoFocus
          open={isEditing}
          fullWidth
          size="small"
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 300,
              },
            },
          }}
        >
          {fileTypeOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      ) : (
        <EditableText
          onClick={handleClick}
          sx={{
            fontSize: '1rem',
            color: theme.palette.text.primary,
          }}
        >
          {fileType || 'Select file type'}
        </EditableText>
      )}
    </Box>
  );
};

export default EditableFileType;
